module.exports = __webpack_public_path__ + "static/media/error.e02c5297.gif";